/* eslint-disable sonarjs/no-duplicate-string */
export default class Nav {
  constructor() {
    this.selectors = {
      subMenu: '.sub-menu',
    };

    this.className = {
      active: 'menu-item--active',
      menuItemHasChildren: 'menu-item-has-children',
      dropdownArrow: 'menu-item__arrow',
      languageSwitcherTrigger: 'language-switcher__trigger',
    };
  }

  init() {
    const suBmenuItems = [ ...document.querySelectorAll(this.selectors.subMenu) ];
    const languageSwitcherTriggers = [ ...document.getElementsByClassName(this.className.languageSwitcherTrigger) ];

    if (suBmenuItems.length === 0) {
      return;
    }

    this.createSubMenuArrows({ suBmenuItems });
    this.handleClicks({ suBmenuItems });
    this.handleLanguageSwitcher({ languageSwitcherTriggers });
  }

  createSubMenuArrows({ suBmenuItems }) {
    suBmenuItems.forEach(item => {
      const closestLi = item.closest('li');
      const arrow = this.createArrow();

      closestLi.classList.add(this.className.menuItemHasChildren);
      closestLi.querySelector('a').appendChild(arrow);
    });
  }

  createArrow() {
    const arrow = document.createElement('span');

    arrow.innerHTML =
      '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.5L6 5.5L11 0.5" stroke="currentColor"/></svg>';

    arrow.classList.add(this.className.dropdownArrow);

    return arrow;
  }

  handleClicks({ suBmenuItems }) {
    suBmenuItems.forEach(item => {
      const closestLi = item.closest('li');

      closestLi.addEventListener('click', event => {
        if (
          event.target.matches(`.${this.className.dropdownArrow}`) ||
          !event.target.getAttribute('href')
        ) {
          event.preventDefault();

          if (event.target.closest(this.selectors.subMenu)) {
            return;
          }

          this.toggleElementClass({ suBmenuItems, item: closestLi });
        }
      });
    });
  }

  handleLanguageSwitcher({ languageSwitcherTriggers }) { // eslint-disable-line class-methods-use-this
    if (!languageSwitcherTriggers) {
      return;
    }

    languageSwitcherTriggers.forEach(languageSwitcherTrigger => {
      languageSwitcherTrigger.addEventListener('click', event => {
        event.preventDefault();

        const languageSwitcher = languageSwitcherTrigger.closest('.language-switcher');

        languageSwitcher.classList.toggle('language-switcher--active');

        const target = document.querySelector('.language-switcher');
        const flag = event.composedPath().some(el => el === target);

        if (flag && document.body.classList.contains('--search-bar-active')) {
          document.body.classList.remove('--search-bar-active');
        }
      });

      document.body.addEventListener('click', evnt => {
        const target = document.querySelector('.language-switcher');
        const flag = evnt.composedPath().some(el => el === target);

        if (!flag) {
          target.classList.remove('language-switcher--active');
        }
      });
    });
  }

  toggleElementClass({ suBmenuItems, item }) {
    suBmenuItems.forEach(element => {
      if (element !== item) {
        element.classList.remove(this.className.active);
      }
    });

    if (this.isSubMenuOpen({ item })) {
      item.classList.remove(this.className.active);

      return;
    }

    item.classList.add(this.className.active);
  }

  isSubMenuOpen({ item }) {
    return item.classList.contains(this.className.active);
  }
}
